import { Button } from '../../../../../../components/button/button';
import { Card } from '../../../../../../components/card/card';
import { Container } from '../../../../../../components/container/container';
import { ExtendableBlock } from '../../../../../../components/extendable-block/extendable-block';
import { Loader } from '../../../../../../components/loader/loader';
import { CompanySocialsInput } from './company-socials-input/company-socials-input';
import s from './company-socials.module.css';
import { useCompanySocials } from './use-company-socials';

export const CompanySocials = () => {
  const {
    disabled,
    toggleDisabled,
    isLoading,
    handleCancel,
    handleSave,
    t,
    handleAdd,
    handleDelete,
    handleSetUrl,
    socials,
  } = useCompanySocials();

  return (
    <Card className={s.feature}>
      {isLoading && <Loader />}
      <div className={s.controls}>
        {!disabled && (
          <Button variant="secondary" onClick={handleSave}>
            {t('Сохранить')}
          </Button>
        )}
        <Button variant="secondary" onClick={disabled ? toggleDisabled : handleCancel}>
          {t(disabled ? 'Изменить' : 'Отменить')}
        </Button>
      </div>
      <Container label={t('Социальные сети')}>
        <ExtendableBlock button={{ children: t('Добавить'), disabled: disabled }} onAdd={handleAdd}>
          <ul className={s.list}>
            {socials.map(({ type, url }, index) => (
              <CompanySocialsInput
                key={index}
                url={url}
                type={type}
                index={index}
                disabled={disabled}
                onChange={handleSetUrl}
                onDelete={handleDelete}
              />
            ))}
          </ul>
        </ExtendableBlock>
      </Container>
    </Card>
  );
};
